import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BasicInfo from "../components/BasicInfo";


const EmailPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Basic Info" />

        {/* EmailLayer */}
        <BasicInfo />


      </MasterLayout>
    </>
  );
};

export default EmailPage;
